<template>
  <div>
    <div class="row justify-content-center justify-content-md-start">
      <div class="col-4 col-md-2">
        <img src="/images/schedule.svg" class="img-fluid d-block" style="width:200px; margin:0 auto">
      </div>
      <div class="col-12 col-8 col-md-10 mb-1">
        <h4 class="my-1" style="color: #0d4d6e">Cursos y horarios con plazas disponibles</h4>
        <div class="top-0 start-0 w-100 box">
          <h4>
            Para <u>matricularte</u>, selecciona nivel, formato (online o presencial) y horario y a continuación rellena el formulario. <br>
            En los grupos que están <u>llenos</u> puedes apuntarte en la lista de espera. <br>
            <u>La lista de espera no te compromete absolutamente a nada.</u> <br>
            Desde que se abra una plaza en ese horario te daremos prioridad.
            <p>Si tienes dudas, contacta con nosotros al 672 077 088 y las resolveremos sobre la marcha.</p>
          </h4>
        </div>
      </div>
    </div>

    <div v-for="(courses, indexx) in coursesdegrees" :key="indexx" class="card card-schedule mb-4">
      <div class="card-body bg-dark pointer" @click="toggleCollapse(indexx)">
        <h6 class="text-white m-0 d-flex justify-content-between align-items-center">
          {{ indexx }}
          <button
            class="btn btn-link btn-sm text-white"
          >
            <i :class="collapseStates[indexx] ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
          </button>
        </h6>
      </div>
      <transition name="fade">
        <div v-show="canShow(indexx)" :key="key">
          <el-collapse v-model="activeNames[indexx]">
            <el-collapse-item
              v-for="(course, index) in courses"
              :key="index"
              :name="index"
            >
              <template slot="title" >
                <span >{{ course.name }}</span>
              </template>
              <div class="boxy">
                <a 
                  v-for="(timetable, index2) in course.timetables"
                  :key="index2"
                  :href="getCourseLink(timetable, course)"
                >
                  <p
                    class="my-1"
                  >
                  <span
                    v-for="(label, index3) in timetable.label_weekdays"
                    v-html="
                      index3 != timetable.label_weekdays.length - 1
                        ? (label + ' y' + '&nbsp;')
                        : label + ' '
                    "
                    :key="index3"
                  ></span>
                    de {{ timetable.start }} a
                    {{ timetable.finish }} 
                    <span
                      v-if="
                        course.timetables.length > 1 &&
                        index2 !== course.timetables.length - 1
                      "
                    >
                    </span>
                    <div class="flashy-container" :style="'background-color: ' + (course.available > 0 ? '#f05333' : '#0d4d6e')">
                      <template v-if="course.available > 0">
                        {{ course.available == 1 ? 'Queda' : 'Quedan' }} solo {{ course.available }} {{ course.available == 1 ? 'plaza' : 'plazas' }}
                      </template>
                      <template v-else>
                        <b style="color: white">Lista de espera</b>
                      </template>
                    </div>              
                  </p>
                </a>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
    </transition>  
    </div>
  </div>
</template>

<script>
export default {
  props: ["coursesdegrees"],
  data() {
    return {
      key: 0,
      activeNames: [],
      collapseStates: {},
      activeNames: [],
      optionsLevels: [
        {
          value: "A1",
          label: "A1",
        },
        {
          value: "A2",
          label: "A2",
        },
        {
          value: "B1",
          label: "B1",
        },
        {
          value: "B2",
          label: "B2",
        },
        {
          value: "C1/C2",
          label: "C1",
        },
        {
          value: "C2",
          label: "C2",
        },
      ],
    };
  },
  created() {
    const keys = Object.keys(this.coursesdegrees);
    keys.forEach((key, i) => {
      this.activeNames[key] = 0;
      if (i == 0) this.collapseStates[key] = true;
      else this.collapseStates[key] = false;
    });
    // for (let i = 0; i < Object.keys(this.coursesdegrees).length; i++) {
      // this.activeNames[Object.keys(this.coursesdegrees)[i]] = 0;
    // }
  },
  methods: {
    getCourseLink(timetable, course) {
      if (course.available > 0) {
        return '/online-registration/user-form?level=' + timetable.level +'&independent_course=false&course_id=' + course.id +'&timetable_id=' + timetable.id
      }
      else {
        return '/waitlist/enroll?level=' + timetable.level +'&course_id=' + course.id +'&timetable_id=' + timetable.id
      }
    },
    toggleCollapse(indexx) {
      this.collapseStates[indexx] = this.collapseStates[indexx] === true ? false : true;
      this.key++
    },
    canShow(indexx) {
      return this.collapseStates[indexx]
    }
  }
};
</script>

<style>
  .card-schedule .el-collapse-item__header,
  .card-schedule .el-collapse-item__wrap{
    padding:1.25rem;
  }
  .card-schedule  .el-collapse-item__header {
    height: auto;
    line-height: inherit;
    background-color: #f8f9fa !important;
    border-bottom: 1px solid #dee2e6 !important;
    font-size: 16px;
    font-weight: bold;
  }
  .card-schedule .el-collapse-item__content {
    padding-bottom: 0px;
    font-size: 16px;
  }
  .flashy-container {
    color: #ffffff;
    padding: 5px 10px;
    border-radius: 5px;
    display: inline-block;
    margin-left: 10px;
    font-weight: bold;
  }

  .boxy *{
    display: inline-block;
  }

  .box {
    background-color: #0d4d6e;
    padding: 15px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    max-height: 80%;
    overflow-wrap: break-word;
    word-break: break-word;
  }

  .box h4 {
    color: white;
    font-size: 1.2rem;
    line-height: 1.5;
    overflow-wrap: break-word;
    word-break: break-word;
  }

  @media (max-width: 600px) {
    .box {
      font-size: 1rem;
      padding: 10px;
      overflow-y: auto;
    }
  }

  .btn-link {
    text-decoration: none;
  }

  .fa-eye,
  .fa-eye-slash {
    font-size: 1.2em;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.25s ease;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  .pointer {
    cursor: pointer !important;
  }


</style>
